import { render, staticRenderFns } from "./border-editor.vue?vue&type=template&id=f579a26a&scoped=true&"
import script from "./border-editor.vue?vue&type=script&lang=js&"
export * from "./border-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f579a26a",
  null
  
)

export default component.exports